/** Economic parent · operational managers · affiliate referrers — three separate relationships. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { btnPrimary, btnSmall, errorText, inputCls } from '../finance/financeUi';

const Row = ({ title, items, testid, render }) => (
  <div data-testid={testid}>
    <p className="text-xs uppercase tracking-wide text-muted-foreground">{title}</p>
    {items.length ? items.map(render) : <p className="text-sm text-muted-foreground">None</p>}
  </div>
);

export function RelationshipsPanel({ rel, names, onChange }) {
  const [mgr, setMgr] = useState('');
  if (!rel) return null;
  const n = (ref) => names[ref?.replace('user:', '')] || ref;
  const end = async (id) => {
    const note = window.prompt('Why is this relationship ending?'); if (!note) return;
    try { await api.request(`/economic-relationships/links/${id}/end`, { method: 'POST', body: JSON.stringify({ note }) }); onChange(); } catch (e) { toast.error(errorText(e)); }
  };
  const addManager = async () => {
    try {
      await api.request('/economic-relationships/links', { method: 'POST', body: JSON.stringify({ relationship_type: 'OPERATIONAL_MANAGER', from_entity_id: `user:${mgr}`, to_entity_id: rel.subject, effective_from: new Date().toISOString().slice(0, 10) }) });
      toast.success('Operational manager assigned (read-only supervisory access)'); setMgr(''); onChange();
    } catch (e) { toast.error(errorText(e)); }
  };
  const link = (lk, who) => (
    <p key={lk.link_id} className="flex items-center gap-2 text-sm" data-testid={`link-${lk.link_id}`}>
      <span>{n(who)}</span><span className="text-xs text-muted-foreground">since {lk.effective_from}{lk.access_profile ? ` · ${lk.access_profile.replace(/_/g, ' ').toLowerCase()}` : ''}</span>
      {lk.relationship_type !== 'ECONOMIC_PARENT' && <button type="button" className={btnSmall} onClick={() => end(lk.link_id)} data-testid={`link-end-${lk.link_id}`}>End</button>}
    </p>
  );
  return (
    <div className="grid gap-4 px-5 py-4 sm:grid-cols-3" data-testid="relationships-panel">
      <Row title="Economic parent (pays / owns economics)" testid="rel-economic-parent" items={rel.economic_parent ? [rel.economic_parent] : []} render={(lk) => link(lk, lk.from_entity_id)} />
      <div className="space-y-2">
        <Row title="Operational managers (supervise only)" testid="rel-managers" items={rel.operational_managers} render={(lk) => link(lk, lk.from_entity_id)} />
        <div className="flex gap-2">
          <select className={`${inputCls} max-w-48`} value={mgr} onChange={(e) => setMgr(e.target.value)} data-testid="rel-manager-select">
            <option value="">Assign a manager…</option>
            {Object.entries(names).filter(([id, v]) => `user:${id}` !== rel.subject && v).map(([id, v]) => <option key={id} value={id}>{v}</option>)}
          </select>
          <button type="button" className={btnPrimary} disabled={!mgr} onClick={addManager} data-testid="rel-manager-add-btn">Assign</button>
        </div>
      </div>
      <Row title="Affiliate referrers" testid="rel-affiliates" items={rel.affiliate_referrers} render={(lk) => link(lk, lk.from_entity_id)} />
    </div>
  );
}
